webpackJsonp([41318205152459],{

/***/ 2536:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/infinite-scrolling-example.54670c1b.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Example = __webpack_require__(33);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _infiniteScrollingExample = __webpack_require__(2536);
	
	var _infiniteScrollingExample2 = _interopRequireDefault(_infiniteScrollingExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Example2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Infinite Scrolling: Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There is an infinite scrolling example in the lore repo called ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/infinite-scrolling' },
	        'infinite-scrolling'
	      ),
	      '. It looks like this:'
	    ),
	    _react2.default.createElement('img', { src: _infiniteScrollingExample2.default, alt: 'Filtering: Example' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example fetches the most starred repositories on GitHub, and allows you to load the next page using infinite-scrolling. If you load more than 10 pages in 60 seconds, you will see an error letting you know you hit the GitHub search API rate limit. If that happens, just wait a minute and refresh the page, and you\'ll load data again.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Video Walk-Through'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This will be added in the future.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-infinite-scrolling-js-bd727e4bae176fe6386a.js